import { api } from '@/lib/api';
import { mutationOptions, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { mutationKeys } from '../mutationKeys';
import { queryKeys } from '../queryKeys';

export const createParcelMutation = () => {
  const queryClient = useQueryClient();

  return mutationOptions({
    mutationKey: mutationKeys.parcels.create(),
    mutationFn: async (orderId: number) => {
      return await api.post(`parcels/create/${orderId}`).json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.orders.all(),
      });
    },
    onError: (error) => {
      toast.error(error.message || 'Failed to create parcel');
    },
  });
};
